import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.js";
import "./styles.css";

// Phone alerts: the service worker shows the push and opens the bet on tap.
if ("serviceWorker" in navigator) {
  void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  // A tapped notification while the app is already open: iOS ignores the
  // worker's navigate(), so the app loads the alert's page itself.
  navigator.serviceWorker.addEventListener("message", (event: MessageEvent) => {
    const data = event.data as { type?: string; url?: string } | null;
    if (data?.type === "open" && typeof data.url === "string")
      window.location.assign(data.url);
  });
}

const root = document.getElementById("root");
if (root === null) throw new Error("Dashboard root element missing");
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={new QueryClient()}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
